import config from '../config';

const SESSION_ID_KEY = 'henosis.analytics.session_id';
const ATTRIBUTION_KEY = 'henosis.analytics.attribution';
const INTERNAL_KEY = 'henosis.analytics.internal_marked';
const UTM_FIELDS = ['source', 'medium', 'campaign', 'content'];

const randomUuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    bytes.forEach((_, index) => { bytes[index] = Math.floor(Math.random() * 256); });
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const createAnalyticsId = randomUuid;

export const getAnalyticsSessionId = () => {
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = randomUuid();
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }
  return sessionId;
};

const getAttribution = () => {
  const existing = sessionStorage.getItem(ATTRIBUTION_KEY);
  if (existing) {
    try { return JSON.parse(existing); } catch (_) { return {}; }
  }
  const params = new URLSearchParams(window.location.search);
  const attribution = {};
  UTM_FIELDS.forEach((field) => {
    const value = params.get(`utm_${field}`);
    if (value) attribution[field] = value.trim().toLowerCase().slice(0, 80);
  });
  sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
  return attribution;
};

const normalizedPath = () => {
  const path = window.location.pathname || '/';
  if (/^\/shared\/[^/]+/.test(path)) return '/shared/:id';
  if (/^\/chat\/[^/]+/.test(path)) return '/chat/:id';
  if (/^\/projects\/[^/]+/.test(path)) return '/projects/:id';
  return path.slice(0, 160);
};

export const trackAnalyticsEvent = (eventName, properties = {}) => {
  if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') return;
  const payload = {
    event_id: randomUuid(),
    event_name: eventName,
    anonymous_session_id: getAnalyticsSessionId(),
    occurred_at: new Date().toISOString(),
    path: normalizedPath(),
    ...getAttribution(),
    properties,
  };
  const url = `${config.apiV2Url}/public/analytics/events`;
  const body = JSON.stringify(payload);
  try {
    if (navigator.sendBeacon) {
      const queued = navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
      if (queued) return;
    }
  } catch (_) {}
  fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {});
};

export const markCurrentSessionInternal = async () => {
  if (sessionStorage.getItem(INTERNAL_KEY) === '1') return;
  try {
    const response = await fetch(`${config.apiV2Url}/analytics/internal-session`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ anonymous_session_id: getAnalyticsSessionId() }),
    });
    if (response.ok) sessionStorage.setItem(INTERNAL_KEY, '1');
  } catch (_) {}
};
